<template>
  <div class="city-office-select">
    <el-select
      v-model="localBranchId"
      placeholder="Выберите офис"
      @change="onBranchChange"
      size="large"
      filterable
      style="width: 50%;"
    >
      <!-- Проходим по списку городов -->
      <el-option-group
        v-for="city in cities"
        :key="'city-' + city.id"
        :label="city.name"
      >
        <!-- Для каждого города рендерим его офисы -->
        <el-option
          v-for="office in city.children || []"
          :key="'office-' + office.id"
          :label="office.name"
          :value="office.id"
        />
      </el-option-group>
    </el-select>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'CityOfficeSelect',
  props: {
    modelValue: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      // Локальная копия выбранного office_id, синхронизируемая с modelValue
      localBranchId: this.modelValue
    };
  },
  computed: {
    ...mapState('cities', ['cities'])
  },
  watch: {
    modelValue(newVal) {
      if (newVal !== this.localBranchId) {
        this.localBranchId = newVal;
      }
    },
    cities: {
      immediate: true,
      handler(citiesList) {
        if (this.localBranchId) return;
        for (const city of citiesList || []) {
          if (Array.isArray(city.children) && city.children.length > 0) {
            this.localBranchId = city.children[0].id;
            // Эмитим наверх, чтобы Calendar.vue тоже узнал о выбранном офисе
            this.$emit('update:modelValue', this.localBranchId);
            break;
          }
        }
      }
    }
  },
  methods: {
    onBranchChange(newId) {
      this.$emit('update:modelValue', newId);
    }
  }
};
</script>

<style scoped>
.city-office-select {
  /* можно добавить ваши отступы, если нужно */
}
</style>